import api from './api';

const vendorService = {
  // Get all vendors with filtering and pagination
  getAllVendors: async (params = {}) => {
    const response = await api.get('/vendors', { params });
    return response.data;
  },

  // Get vendor statistics
  getVendorStats: async () => {
    const response = await api.get('/vendors/stats');
    return response.data;
  },

  // Get vendor by ID
  getVendorById: async (id) => {
    const response = await api.get(`/vendors/${id}`);
    return response.data;
  },

  // Create new vendor
  createVendor: async (vendorData) => {
    const response = await api.post('/vendors', vendorData);
    return response.data;
  },

  // Update vendor
  updateVendor: async (id, vendorData) => {
    const response = await api.put(`/vendors/${id}`, vendorData);
    return response.data;
  },

  // Delete vendor
  deleteVendor: async (id) => {
    const response = await api.delete(`/vendors/${id}`);
    return response.data;
  },

  // Update vendor status
  updateVendorStatus: async (id, status) => {
    const response = await api.patch(`/vendors/${id}/status`, { status });
    return response.data;
  },

  // Approve vendor
  approveVendor: async (id) => {
    const response = await api.patch(`/vendors/${id}/approve`);
    return response.data;
  },

  // Reject vendor
  rejectVendor: async (id, reason) => {
    const response = await api.patch(`/vendors/${id}/reject`, { reason });
    return response.data;
  },

  // Vendor Contacts
  getVendorContacts: async (vendorId) => {
    const response = await api.get(`/vendors/${vendorId}/contacts`);
    return response.data;
  },

  addVendorContact: async (vendorId, contactData) => {
    const response = await api.post(`/vendors/${vendorId}/contacts`, contactData);
    return response.data;
  },

  updateVendorContact: async (vendorId, contactId, contactData) => {
    const response = await api.put(`/vendors/${vendorId}/contacts/${contactId}`, contactData);
    return response.data;
  },

  deleteVendorContact: async (vendorId, contactId) => {
    const response = await api.delete(`/vendors/${vendorId}/contacts/${contactId}`);
    return response.data;
  },

  // Vendor Contracts
  getVendorContracts: async (vendorId) => {
    const response = await api.get(`/vendors/${vendorId}/contracts`);
    return response.data;
  },

  addVendorContract: async (vendorId, contractData) => {
    const response = await api.post(`/vendors/${vendorId}/contracts`, contractData);
    return response.data;
  },

  updateVendorContract: async (vendorId, contractId, contractData) => {
    const response = await api.put(`/vendors/${vendorId}/contracts/${contractId}`, contractData);
    return response.data;
  },

  deleteVendorContract: async (vendorId, contractId) => {
    const response = await api.delete(`/vendors/${vendorId}/contracts/${contractId}`);
    return response.data;
  },

  updateContractStatus: async (vendorId, contractId, status) => {
    const response = await api.patch(`/vendors/${vendorId}/contracts/${contractId}/status`, { status });
    return response.data;
  },

  // Vendor Services
  getVendorServices: async (vendorId) => {
    const response = await api.get(`/vendors/${vendorId}/services`);
    return response.data;
  },

  addVendorService: async (vendorId, serviceData) => {
    const response = await api.post(`/vendors/${vendorId}/services`, serviceData);
    return response.data;
  },

  updateVendorService: async (vendorId, serviceId, serviceData) => {
    const response = await api.put(`/vendors/${vendorId}/services/${serviceId}`, serviceData);
    return response.data;
  },

  deleteVendorService: async (vendorId, serviceId) => {
    const response = await api.delete(`/vendors/${vendorId}/services/${serviceId}`);
    return response.data;
  },
  getVendorApprovals: async (vendorId) => {
    const response = await api.get(`/vendor-dashboard/approvals`);
    return response.data;
  },
  updateVendorApprovals: async (vendorId,  vendorData) => {
    const response = await api.put(`/vendor-dashboard/approvals/${vendorId}`, vendorData);
    return response.data;
  },
};

export default vendorService;

